// src/components/AuditDefenseNote.js
import React from 'react';

function AuditDefenseNote() {
  return (
    <div className="audit-note">
      <p><strong>Note on Audits:</strong> This tool provides tax estimates based on your input. For complex situations or audit defense, we strongly recommend consulting with a qualified Certified Public Accountant (CPA).</p>
    </div>
  );
}

export default AuditDefenseNote;